<div class="page-body">
  <div class="left-section">
    <!-- Problem Section -->
    <div class="problem-box">
      <div class="content-subtitle">Problem</div>
      <div class="content-text">{{ summaryData[0].dataValue }}</div>
    </div>

    <!-- Topics Section -->
    <div class="topics-box">
      <div class="topics-subtitle">
        Most interactions involved the following topics:
      </div>
      <div class="topics-list">
        <ng-container *ngFor="let topic of summaryData[1]?.dataValue?.split(', ')">
          <div class="topic-item-container">
            <div class="topic-item">{{ topic }}</div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Root Causes Section -->
    <div class="root-causes-box">
      <div class="root-causes-subtitle">Top Root Causes</div>
      <div class="root-cause-container">
        <ng-container *ngFor="let cause of summaryData[2]?.dataValue?.split(', ')">
          <div class="cause-item">
            <div class="bullet">✴️</div> {{ cause }}
          </div>
        </ng-container>
      </div>

    </div>

    <div class="chart-section">
      <!-- Interaction Channels -->
      <div class="interaction-box">
        <div class="interaction-subtitle">Interaction Channels</div>
        <chart [pieChartData]="chartData.channelData"></chart>
      </div>

      <!-- Call Resolution -->
      <div class="call-resolution-box">
        <div class="call-resolution-subtitle">Call Resolution</div>
        <chart [pieChartData]="chartData.resolutionData"></chart>
      </div>
    </div>

    <!-- Recent Conversations -->
    <div class="recent-conversations-box">
      <div class="recent-conversations-subtitle">Recent Conversations Overview</div>
      <div class="conversation-list">
        <ng-container *ngFor="let conversation of summaryData[3]?.dataValue?.split(', '); let i = index">
          <div class="conversation-item">
            <span>Conversation {{ i + 1 }}:</span>
            <img src="assets/icons/emoji_emotions.svg" alt="emoji_emotions" class="emoji-icon" />
            <span>{{ conversation }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="right-section">
    <div class="section-title">Overview</div>

    <div class="calculated-data">
      <ng-container *ngFor="let item of calculatedData">
        <div class="data">
          <div class="data-title">{{ item.dataTitle }}</div>
          <div class="data-value">{{ item.dataValue }}</div>
          <div class="line-div"></div>
        </div>
      </ng-container>
    </div>

    <div class="disclaimer">
      <b>Disclaimer:</b><br>{{ disclaimer }}
    </div>
    <div class="poweredby">
      Powered by Rozie<sup>AI</sup> {{ poweredBy }}
    </div>
  </div>
</div>